import * as THREE from 'three';

export class VideoPlane {
  constructor(scene, width, height, settings, planeName, planePosition, planeMaterialName, widthPlane, heightPlane, renderOrder) {
    this.settings = settings;
    this.width = width;
    this.height = height;
    this.scene = scene;

    const geometry = new THREE.PlaneGeometry(widthPlane, heightPlane, 20, 20);
   const material = new THREE.MeshBasicMaterial({
      color: 0x00ffff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.5
    });
    
    material.name = planeMaterialName;
    
    this.plane = new THREE.Mesh(geometry, material);
    this.plane.renderOrder = renderOrder;
    this.plane.name = planeName;
    this.plane.position.set(planePosition.x, planePosition.y, planePosition.z);
    
    // Exposer les propriétés pour un accès facile
    this.position = this.plane.position;
    this.material = material;
    this.mesh = this.plane;
    this.geometry = geometry;
    
    this.scene.add(this.plane);
    
    return this;
  }

  /**
   * Nettoyage des ressources pour éviter les memory leaks
   */
  dispose() {
    // Retirer de la scène
    if (this.scene && this.plane) {
      this.scene.remove(this.plane);
    }

    // Disposer de la géométrie
    if (this.geometry) {
      this.geometry.dispose();
      this.geometry = null;
    }

    // Disposer du matériau
    if (this.material) {
      // Disposer des textures dans le matériau si présentes
      if (this.material.map) {
        this.material.map.dispose();
      }
      if (this.material.alphaMap) {
        this.material.alphaMap.dispose();
      }
      this.material.dispose();
      this.material = null;
    }

    this.plane = null;
    this.mesh = null;
  }
}
